<script>
import config from '../../../common/genericPanelConf';
import Service from '../../../services/equipment-operation';
import TankManagementService from '../../../services/tank-management';
import { required  } from "@vuelidate/validators";
import { useVuelidate } from "@vuelidate/core";
import CommonConstants from '../../../common/Constants';
import Utils from '../../../common/Utils';
import ResponsiveButton from '../../generic/ResponsiveButton.vue'
import GenericCustomAutocompleteV2 from '../../generic/GenericCustomAutocompleteV2.vue'
import GenericDataTable from '../../generic/GenericDataTable.vue'
import LabelField from '../../generic/LabelField.vue'
// import Toolbar from 'primevue/toolbar';
import Calendar from 'primevue/calendar';
import Chart from 'primevue/chart';
import DialogTankInformation from '../TankInformationDialog.vue'

export default{
    setup: () => ({ v$: useVuelidate() }),
    props: [],
    components: {
        //Toolbar, 
        Chart,
        Calendar, 
        GenericDataTable,
        ResponsiveButton, GenericCustomAutocompleteV2, LabelField, DialogTankInformation
    },
    created(){
        this.configuration = config.getConfiguration('TankOperations');
    },
    data(){
        return{
            backgroundColor: ["#42A5F5","#66BB6A","#FFA726"],
            hoverBackgroundColor: ["#64B5F6","#81C784","#FFB74D"],

            submitted: false,
            winWidth: window.innerWidth,
            filters: {
                plantCode: "ISABSUD", 
                tankCode: null,
                dateFrom: Utils.formatDatePlusDays(new Date(), -10),
                dateTo: Utils.formatDatePlusDays(new Date(), 0)
            },
            selectedItem: null,
            operations: [],
            loading: false,
            configuration: null,
            tankInfo: {},
            tankContent: {
                labels: [],
                datasets: [
                    {
                        data: [],
                        backgroundColor: ["#42A5F5","#66BB6A","#FFA726", "#be5683", "#af4154"],
                        hoverBackgroundColor: ["#64B5F6","#81C784","#FFB74D", "#db0a5b", "#96281b"]
                    }
                ]
            },
            showTankInfo: false,
            generalTankInfo: {}
        }
    },
    validations(){
        return {
        filters: {
            plantCode: {required},
            tankCode: {required},
            dateFrom: {required},
            dateTo: {required}
        }
        }
    },
    mounted(){
         window.addEventListener('resize', () => {
            this.winWidth = window.innerWidth;
        });
        let cacheFilters = null;
        let cacheData = this.$store.getters['cacheDataStore/getGridCache']('TankOperationsGrid');
        if(cacheData){
            cacheFilters = {};
            for(let i = 0; i < cacheData.length; i++){
                let element = cacheData[i];
                cacheFilters[element.property] = element;
                // let k = element.property.charAt(0).toLowerCase() + element.property.slice(1);
                this.filters[element.propName] = element.value;
            }
            if(cacheFilters){
                this.loadGrid();
                this.loadTankContent();
            }
        }
    },
    computed: {
        constants(){
            return CommonConstants;
        },
        utils(){
            return Utils;
        },
        uiPermissions(){
            return this.$store.getters['security/uiPermissions'];
        },
        feetPositionLabel(){
            if(this.tankInfo && this.tankInfo.feetPosition){
                if(this.tankInfo.feetPosition == 'D'){
                    return this.$t('calculatorTankDevelopment.footPositionD')
                }
                if(this.tankInfo.feetPosition == 'U'){
                    return this.$t('calculatorTankDevelopment.footPositionH')
                }
                return this.tankInfo.feetPosition;
            }
            return '';
        }
    },
    methods: {
        populateCalculator(data){
            let opData = {...data};
            opData.idOperativePlan = null;
            opData.operationDate = Utils.dateToCurrentTimeZone(opData.operationDate);
            this.$emit('populateCalculator', opData);
        },
        loadGrid(){
            let filters = this.prepareFilters();
            this.$refs.operationsGrid.filterFromView(filters);

            let body = {
                tankCode: this.tankInfo.code
            }
           
            Service.equipmentOperationTankInfo(body, (response) => {
                this.$store.dispatch("generic/setLoading", false);
                if(response.success){
                   this.generalTankInfo = response.data;

                   if(this.generalTankInfo.tankContentLayersList){
                    for(let i = 0; i < this.generalTankInfo.tankContentLayersList.length; i++){
                        let item = this.generalTankInfo.tankContentLayersList[i];
                        item.introductionDate = item.introductionDate ? Utils.dateToCurrentTimeZone(item.introductionDate) : null;
                    }
                   }                  
                }
            })
        },
        printReport() {
            let params = {};
            params.start = 0;
            params.limit = 100000;
            params.sort = JSON.stringify([{property: 'OperationDate', direction: 'asc'}])
            params.filter = JSON.stringify(this.prepareFilters());
            this.$store.dispatch("generic/setLoading", true);
            Service.printTankOperationReport(params, (response) => {
                this.$store.dispatch("generic/setLoading", false);
                if(response.success){
                    var fileURL = window.URL.createObjectURL(new Blob([response.data]));
                    var fileLink = document.createElement('a');
            
                    fileLink.href = fileURL;
                    fileLink.setAttribute('download', 'TankOperationsReport.pdf');
                    document.body.appendChild(fileLink);
            
                    fileLink.click();
                }else{
                    this.$toast.add({detail: response.message && response.message != '' ? response.message :  this.$t('messages.generic_error_message'), life:3000, severity:'error'});
                }
            })
        },
        printReportExcel() {
            let params = {};
            params.start = 0;
            params.limit = 100000;
            params.sort = JSON.stringify([{property: 'OperationDate', direction: 'asc'}])
            params.filter = JSON.stringify(this.prepareFilters());
            this.$store.dispatch("generic/setLoading", true);
            Service.printTankOperationReportExcel(params, (response) => {
                this.$store.dispatch("generic/setLoading", false);
                if(response.success){
                    var fileURL = window.URL.createObjectURL(new Blob([response.data]));
                    var fileLink = document.createElement('a');
            
                    fileLink.href = fileURL;
                    fileLink.setAttribute('download', 'TankOperationsReport.xlsx');
                    document.body.appendChild(fileLink);
            
                    fileLink.click();
                }else{
                    this.$toast.add({detail: response.message && response.message != '' ? response.message :  this.$t('messages.generic_error_message'), life:3000, severity:'error'});
                }
            })
        },
        prepareFilters() {
            let filters = [];

            // filters.push({
            //     operator: 'eq',
            //     value: this.filters.plantCode,
            //     property: 'PlantCode',
            //     propName: 'plantCode'
            // });
            filters.push({
                operator: 'eq',
                value: this.filters.tankCode,
                property: 'TankCode',
                propName: 'tankCode'
            });

            filters.push({
                operator: '>=',
                value: this.filters.dateFrom,
                property: 'OperationDate',
                propName: 'dateFrom'
            });

            filters.push({
                operator: '<=',
                value: Utils.formatEndDate(this.filters.dateTo),
                property: 'OperationDate',
                propName: 'dateTo'
            });

            let cacheData = {
                name: 'TankOperationsGrid',
                filters: filters
            };
            this.$store.dispatch("cacheDataStore/setGridCache", cacheData);

            return filters;
        },
        loadTankContent(){

            // let tankContentFilters = [
            //     {
            //         operator: 'eq',
            //         value: this.filters.tankCode,
            //         property: 'TankCode'
            //     }
            // ];
            this.tankContent = {};

            
            let tankContentParams = {
                tankCode: this.filters.tankCode,
            }

            Service.getTankContentGrid(tankContentParams, response => {
                if(response.success){
                    let data = response.data;

                    let tankContent = {
                        labels: [],
                        datasets: [
                            {
                                data: [],
                                backgroundColor: [],
                                hoverBackgroundColor: []
                            }
                        ]
                    };

                    for(let i=0; i<data.length; i++){
                        let item = data[i];
                        tankContent.labels.push(item.productCode + '-' + item.productDescription);
                        tankContent.datasets[0].data.push(item.accountingStockWeight);

                        let colorIndex = i > this.backgroundColor.length - 1 ? (i % this.backgroundColor.length -1) : i;

                        tankContent.datasets[0].backgroundColor.push(this.backgroundColor[colorIndex]);
                        tankContent.datasets[0].hoverBackgroundColor.push(this.hoverBackgroundColor[colorIndex]);

                    }

                    this.tankContent = tankContent;
                }
            });
        },
        loadOperations(valid){
            this.submitted = true;
            if(valid){
                this.selectedItem = null;

                this.loadGrid();
                this.loadTankContent();

            }
        },
        addOperation(){
           // let uri = `/tank/operations/0`;
            // this.$router.push(uri);

            this.$router.push(
                { 
                    name: 'tank-operation-detail',
                    params: {
                        id: 0
                    },
                    query: { tankCode: this.filters.tankCode, plantCode: this.filters.plantCode }
                }
            )
        },
        updateOperation(){

        },
        onTankSelected(event){
            if(event && event.value){
                TankManagementService.getTankByCode(event.value.label, response => {
                    if(response.success){
                        let data = response.data;
                        this.tankInfo = data;
                    }
                });
            }
        },
        onPlantSelected(event){
            let plantId = event.value.id;

            let tankApi = `masterdata/equipment-combo?getOnlyValid=true&type=SERB&plantId=${plantId}`;
            this.$refs.tankSelectAC.loadOptions(tankApi);
        },
        formatInteger(n){
            return n ? n.toLocaleString() : null;
        },
        formatDecimal(n, digits){
            return n ? n.toLocaleString(undefined, {minimumFractionDigits: digits, maximumFractionDigits: digits}) : null;
            
        },
        closeTankInformationDialog(value){
            this.showTankInfo = !value;
        },
    }
};

</script>

<template>
    <main>
        <DialogTankInformation :visible="showTankInfo" :tankCode="this.tankInfo.code" @close-tank-information="closeTankInformationDialog"/>
        
        <div class="formgrid grid">
            <div class="col-12 lg:col-2 field">
                <label for="plant" :class="{'p-error':v$.filters.plantCode.$invalid && submitted}">{{$t('registryPlant.fk')}}</label>
                <GenericCustomAutocompleteV2
                    field="label"
                    :onItemSelect="onPlantSelected"
                    v-model="filters.plantCode"
                    api="masterdata/registry-plant"
                    :format="{ label: 'description', value: 'code' }"
                    :class="{'p-invalid':v$.filters.plantCode.$invalid && submitted, 'p-inputtext-sm w-full': true}" />
                <div v-if="(v$.filters.plantCode.$invalid && submitted) || v$.filters.plantCode.$pending.$response">
                    <small class="p-error" v-for="error in v$.filters.plantCode.$silentErrors" :key="error.$validator">
                        {{error.$message}}
                    </small>
                </div>
            </div>
            <div class="col-12 lg:col-2 field">
                <label for="tank" :class="{'p-error':v$.filters.tankCode.$invalid && submitted}">{{$t('tankOperations.tank')}}</label>
                <GenericCustomAutocompleteV2
                    :onItemSelect="onTankSelected"
                    ref="tankSelectAC"
                    :class="{'p-invalid':v$.filters.tankCode.$invalid && submitted, 'p-inputtext-sm w-full': true}"
                    v-model="filters.tankCode"
                    name="tank-management-tank-combo"
                    :format="{ label: 'label', value: 'label' }"
                    api="masterdata/equipment-combo?getOnlyValid=true&type=SERB" />
                <div v-if="(v$.filters.tankCode.$invalid && submitted) || v$.filters.tankCode.$pending.$response">
                    <small class="p-error" v-for="error in v$.filters.tankCode.$silentErrors" :key="error.$validator">
                        {{error.$message}}
                    </small>
                </div>
            </div>
            <div class="col-12 lg:col-2 field">
                <label for="from" :class="{'p-error':v$.filters.dateFrom.$invalid && submitted}">{{$t('from')}}</label>
                <Calendar
                    :class="{'p-invalid':v$.filters.dateFrom.$invalid && submitted, 'p-inputtext-sm w-full': true}"
                    :placeholder="constants.DATE_PLACEHOLDER_POINT_ONLY_DATE"
                    :dateFormat="constants.DATE_FORMAT_POINT"
                    :showTime="false"
                    v-model="filters.dateFrom"
                    :showIcon="true" :showButtonBar="true" :yearNavigator="true" />
                <div v-if="(v$.filters.dateFrom.$invalid && submitted) || v$.filters.dateFrom.$pending.$response">
                    <small class="p-error" v-for="error in v$.filters.dateFrom.$silentErrors" :key="error.$validator">
                        {{error.$message}}
                    </small>
                </div>
            </div>
            <div class="col-12 lg:col-2 field">
                <label for="to" :class="{'p-error':v$.filters.dateTo.$invalid && submitted}">{{$t('to')}}</label>
                <Calendar
                    :class="{'p-invalid':v$.filters.dateTo.$invalid && submitted, 'p-inputtext-sm w-full': true}"
                    :placeholder="constants.DATE_PLACEHOLDER_POINT_ONLY_DATE"
                    :dateFormat="constants.DATE_FORMAT_POINT"
                    :showTime="false"
                    v-model="filters.dateTo"
                    :showIcon="true" :showButtonBar="true" :yearNavigator="true" />
                <div v-if="(v$.filters.dateTo.$invalid && submitted) || v$.filters.dateTo.$pending.$response">
                    <small class="p-error" v-for="error in v$.filters.dateTo.$silentErrors" :key="error.$validator">
                        {{error.$message}}
                    </small>
                </div>
            </div>
            <div class="col-12 lg:col-4 my-5">
                <ResponsiveButton :label="$t('tankManagement.load')" :disabled="!uiPermissions('tankOperationsLoadButton').isEnabled" icon="pi pi-replay" class="p-button-sm m-1" @click="loadOperations(!v$.$invalid)"/>
                <ResponsiveButton :label="$t('tankOperations.btn.addOperation')" :disabled="!uiPermissions('tankOperationsAddButton').isEnabled" icon="pi pi-plus" class="p-button-sm p-button-outlined m-1" @click="addOperation"/>
                <!-- <ResponsiveButton :label="$t('tankOperations.btn.updateOperation')" icon="pi pi-pencil" class="p-button-sm p-button-outlined m-1" @click="updateOperation" :disabled="!uiPermissions('tankOperationsEditButton').isEnabled || !selectedItem"/> -->
                <ResponsiveButton :label="$t('tankOperations.btn.export')" :disabled="!uiPermissions('tankOperationsExportButton').isEnabled" icon="pi pi-file" class="p-button-sm p-button-outlined m-1" @click="printReport"/>
                <ResponsiveButton :label="$t('tankOperations.btn.export')" :disabled="!uiPermissions('tankOperationsExportButton').isEnabled" icon="pi pi-file-excel" class="p-button-sm p-button-outlined m-1" @click="printReportExcel"/>
                <ResponsiveButton :label="$t('tankOperations.btn.showTankInfo')" icon="pi pi-database" class="p-button-sm p-button-outlined m-1" @click="showTankInfo = !showTankInfo"/>
            </div>
        </div>
        <div class="grid">
            <div class="col-12 lg:col-3" style="margin-top: 20px;" v-if="showTankInfo">
                <Card style="m-1">
                    <template #title>
                        {{$t('tankOperations.mainInfo')}}
                    </template>
                    <template #content>
                        <LabelField :value="tankInfo.type" :label="$t('tankManagementTypes.fk')"/>
                        <LabelField :value="tankInfo.maxLevel" :label="$t('tankManagement.maxLevel')"/>
                        <LabelField :value="tankInfo.minLevel" :label="$t('tankManagement.minLevel')"/>
                        <LabelField :value="tankInfo.inextricableVolume" :label="$t('tankManagement.inextricableVolume')"/>
                        <LabelField :value="tankInfo.maxVolume" :label="$t('tankManagement.maxVolume')"/>
                        <LabelField :value="tankInfo.roofWeight" :label="$t('tankOperations.roofWeight')"/>
                        <LabelField :value="feetPositionLabel" :label="$t('tankOperations.feetPosition')"/>
                        <LabelField :value="tankInfo.calibrationTemperature" :label="$t('tankOperations.calibrationTemperature')"/>
                        <LabelField :value="tankInfo.highFeetMinValue" :label="$t('tankOperations.highFeetMinValue')"/>
                        <LabelField :value="tankInfo.lowFeetMinValue" :label="$t('tankOperations.lowFeetMinValue')"/>
                        <LabelField :value="tankInfo.highFeetMaxValue" :label="$t('tankOperations.highFeetMaxValue')"/>
                        <LabelField :value="tankInfo.lowFeetMaxValue" :label="$t('tankOperations.lowFeetMaxValue')"/>
                        <LabelField :value="tankInfo.insulated != null ? (tankInfo.insulated ?  $t('yes') : $t('no')) : ''" :label="$t('tankManagement.insulated')"/>
                        
                    </template>
                </Card>
                
                <Card style="m-4">
                    <template #title>
                        {{$t('tankOperations.tankContent')}}
                    </template>
                    <template #content>
                        <Chart type="pie" :data="tankContent" :width="150" :height="100"/>
                    </template>
                </Card>
            </div>
            <div :class="{'col-12': true, 'lg:col-9': showTankInfo}" style="'height: 70vh;'">
                <GenericDataTable :configuration="configuration" :category="'tank'" :name="'operations'" ref="operationsGrid" @populate-calculator="populateCalculator"/>
            </div>
        </div>
    </main>
</template>
